import {ReportData} from "../../../reports/report.data";
import {field} from "@fedeltapointofsale/data-client";

export class TabReportData extends ReportData<TabReportData> {
    @field summary: boolean = true;
    @field exclusive: boolean = true;
}
